// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/jobs.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ActivityLite } from "./actions_pb";
import { file_cortado_v1_actions } from "./actions_pb";
import type { BookingStageEnum, EventStageEnum, InquiryStageEnum, JobActivityCategoryEnum, JobBoardStageEnum, JobEventSourceEnum, JobPaymentStateEnum, JobPhaseEnum, JobSortDirectionEnum, JobSortFieldEnum, JobStatusEnum, JobWaitingOnEnum, PaymentScheduleStatusEnum, QuoteStatusEnum, UserSchedulingRoleEnum, UserSchedulingStatusEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/jobs.proto.
 */
export const file_cortado_v1_jobs: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_actions, file_cortado_v1_settings, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * Job is the persisted root for one inquiry or one direct booking.
 * Phase, status, waiting_on, and payment_state are derived and never stored.
 *
 * @generated from message cortado.v1.Job
 */
export type Job = Message<"cortado.v1.Job"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * @generated from field: optional string inquiry_id = 4;
   */
  inquiryId?: string;

  /**
   * @generated from field: optional string accepted_quote_id = 5;
   */
  acceptedQuoteId?: string;

  /**
   * @generated from field: optional string booking_id = 6;
   */
  bookingId?: string;

  /**
   * @generated from field: string title = 7;
   */
  title: string;

  /**
   * @generated from field: cortado.v1.JobPhaseEnum phase = 20;
   */
  phase: JobPhaseEnum;

  /**
   * @generated from field: cortado.v1.JobStatusEnum status = 21;
   */
  status: JobStatusEnum;

  /**
   * @generated from field: cortado.v1.JobWaitingOnEnum waiting_on = 22;
   */
  waitingOn: JobWaitingOnEnum;

  /**
   * @generated from field: cortado.v1.JobPaymentStateEnum payment_state = 23;
   */
  paymentState: JobPaymentStateEnum;

  /**
   * @generated from field: optional string contact_first_name = 30;
   */
  contactFirstName?: string;

  /**
   * @generated from field: optional string contact_last_name = 31;
   */
  contactLastName?: string;

  /**
   * @generated from field: optional string contact_company_name = 32;
   */
  contactCompanyName?: string;

  /**
   * @generated from field: optional int32 latest_quote_number = 33;
   */
  latestQuoteNumber?: number;

  /**
   * @generated from field: optional int64 quoted_cents = 34;
   */
  quotedCents?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_event_date = 35;
   */
  firstEventDate?: Timestamp;

  /**
   * @generated from field: optional string assigned_to = 36;
   */
  assignedTo?: string;

  /**
   * @generated from field: repeated string quote_ids = 40;
   */
  quoteIds: string[];

  /**
   * @generated from field: repeated string event_ids = 41;
   */
  eventIds: string[];

  /**
   * @generated from field: repeated string invoice_ids = 42;
   */
  invoiceIds: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 63;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.Job.
 * Use `create(JobSchema)` to create a new message.
 */
export const JobSchema: GenMessage<Job> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 0);

/**
 * JobLite is the list-row projection of a Job.
 *
 * @generated from message cortado.v1.JobLite
 */
export type JobLite = Message<"cortado.v1.JobLite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * @generated from field: optional string inquiry_id = 4;
   */
  inquiryId?: string;

  /**
   * @generated from field: optional string booking_id = 5;
   */
  bookingId?: string;

  /**
   * @generated from field: string title = 6;
   */
  title: string;

  /**
   * @generated from field: cortado.v1.JobPhaseEnum phase = 10;
   */
  phase: JobPhaseEnum;

  /**
   * @generated from field: cortado.v1.JobStatusEnum status = 11;
   */
  status: JobStatusEnum;

  /**
   * @generated from field: cortado.v1.JobWaitingOnEnum waiting_on = 12;
   */
  waitingOn: JobWaitingOnEnum;

  /**
   * @generated from field: cortado.v1.JobPaymentStateEnum payment_state = 13;
   */
  paymentState: JobPaymentStateEnum;

  /**
   * @generated from field: optional string contact_first_name = 20;
   */
  contactFirstName?: string;

  /**
   * @generated from field: optional string contact_last_name = 21;
   */
  contactLastName?: string;

  /**
   * @generated from field: optional string contact_company_name = 22;
   */
  contactCompanyName?: string;

  /**
   * @generated from field: optional int32 latest_quote_number = 23;
   */
  latestQuoteNumber?: number;

  /**
   * @generated from field: optional int64 quoted_cents = 24;
   */
  quotedCents?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_event_date = 25;
   */
  firstEventDate?: Timestamp;

  /**
   * @generated from field: optional string assigned_to = 26;
   */
  assignedTo?: string;

  /**
   * Total event count for this job (same events first_event_date considers).
   *
   * @generated from field: int32 event_count = 27;
   */
  eventCount: number;

  /**
   * Last event date (for date range display alongside first_event_date).
   *
   * @generated from field: optional google.protobuf.Timestamp last_event_date = 28;
   */
  lastEventDate?: Timestamp;

  /**
   * Pipeline board column; refines phase. See JobBoardStageEnum.
   *
   * @generated from field: cortado.v1.JobBoardStageEnum board_stage = 14;
   */
  boardStage: JobBoardStageEnum;

  /**
   * Sum of amount_paid_cents over the job's non-cancelled invoices (the same
   * per-invoice figure Invoice.amount_paid_cents reports).
   *
   * @generated from field: int64 paid_cents = 29;
   */
  paidCents: bigint;

  /**
   * Sum of guest counts over the same events event_count counts. Unset when
   * none of those events has a guest count.
   *
   * @generated from field: optional int32 guest_count = 30;
   */
  guestCount?: number;

  /**
   * Sum of total_cents over the job's non-cancelled invoices (same inclusion
   * rule as paid_cents; drafts are included).
   *
   * @generated from field: int64 invoiced_cents = 31;
   */
  invoicedCents: bigint;

  /**
   * Sum of amount_due_cents over the same non-cancelled invoices.
   *
   * @generated from field: int64 due_cents = 32;
   */
  dueCents: bigint;

  /**
   * Effective status of the same quote latest_quote_number/quoted_cents come
   * from. UNKNOWN when the job has no quote.
   *
   * @generated from field: cortado.v1.QuoteStatusEnum latest_quote_status = 33;
   */
  latestQuoteStatus: QuoteStatusEnum;

  /**
   * One bar segment per payment schedule item, for the Pipeline "Quoted /
   * paid" progress bar. See JobPaymentSegment for the source per job phase.
   *
   * @generated from field: repeated cortado.v1.JobPaymentSegment payment_segments = 34;
   */
  paymentSegments: JobPaymentSegment[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.JobLite.
 * Use `create(JobLiteSchema)` to create a new message.
 */
export const JobLiteSchema: GenMessage<JobLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 1);

/**
 * JobPaymentSegment is one payment-schedule bar segment for JobLite's
 * payment_segments. Invoiced jobs get one segment per schedule item (or one
 * synthetic segment for an invoice with no schedule); quote-only jobs get one
 * segment per the latest quote's payment schedule instead.
 *
 * @generated from message cortado.v1.JobPaymentSegment
 */
export type JobPaymentSegment = Message<"cortado.v1.JobPaymentSegment"> & {
  /**
   * @generated from field: int64 amount_cents = 1;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentScheduleStatusEnum status = 2;
   */
  status: PaymentScheduleStatusEnum;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;
};

/**
 * Describes the message cortado.v1.JobPaymentSegment.
 * Use `create(JobPaymentSegmentSchema)` to create a new message.
 */
export const JobPaymentSegmentSchema: GenMessage<JobPaymentSegment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 2);

/**
 * @generated from message cortado.v1.GetJobRequest
 */
export type GetJobRequest = Message<"cortado.v1.GetJobRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;
};

/**
 * Describes the message cortado.v1.GetJobRequest.
 * Use `create(GetJobRequestSchema)` to create a new message.
 */
export const GetJobRequestSchema: GenMessage<GetJobRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 3);

/**
 * @generated from message cortado.v1.GetJobResponse
 */
export type GetJobResponse = Message<"cortado.v1.GetJobResponse"> & {
  /**
   * @generated from field: cortado.v1.Job job = 1;
   */
  job?: Job;
};

/**
 * Describes the message cortado.v1.GetJobResponse.
 * Use `create(GetJobResponseSchema)` to create a new message.
 */
export const GetJobResponseSchema: GenMessage<GetJobResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 4);

/**
 * @generated from message cortado.v1.JobListFilters
 */
export type JobListFilters = Message<"cortado.v1.JobListFilters"> & {
  /**
   * @generated from field: repeated cortado.v1.JobPhaseEnum phases = 1;
   */
  phases: JobPhaseEnum[];

  /**
   * @generated from field: repeated cortado.v1.JobStatusEnum statuses = 2;
   */
  statuses: JobStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.InquiryStageEnum inquiry_stages = 3;
   */
  inquiryStages: InquiryStageEnum[];

  /**
   * @generated from field: repeated cortado.v1.BookingStageEnum booking_stages = 4;
   */
  bookingStages: BookingStageEnum[];

  /**
   * @generated from field: repeated cortado.v1.JobPaymentStateEnum payment_states = 5;
   */
  paymentStates: JobPaymentStateEnum[];

  /**
   * @generated from field: repeated cortado.v1.JobWaitingOnEnum waiting_on = 6;
   */
  waitingOn: JobWaitingOnEnum[];

  /**
   * @generated from field: optional string assigned_to_id = 7;
   */
  assignedToId?: string;

  /**
   * @generated from field: optional string contact_id = 8;
   */
  contactId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_start = 9;
   */
  eventStart?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_end = 10;
   */
  eventEnd?: Timestamp;

  /**
   * @generated from field: optional string search = 11;
   */
  search?: string;

  /**
   * @generated from field: optional bool include_archived = 12;
   */
  includeArchived?: boolean;

  /**
   * @generated from field: repeated cortado.v1.JobBoardStageEnum board_stages = 13;
   */
  boardStages: JobBoardStageEnum[];
};

/**
 * Describes the message cortado.v1.JobListFilters.
 * Use `create(JobListFiltersSchema)` to create a new message.
 */
export const JobListFiltersSchema: GenMessage<JobListFilters> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 5);

/**
 * @generated from message cortado.v1.ListJobsRequest
 */
export type ListJobsRequest = Message<"cortado.v1.ListJobsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.JobListFilters filters = 2;
   */
  filters?: JobListFilters;

  /**
   * @generated from field: cortado.v1.JobSortFieldEnum sort_field = 3;
   */
  sortField: JobSortFieldEnum;

  /**
   * @generated from field: cortado.v1.JobSortDirectionEnum sort_direction = 4;
   */
  sortDirection: JobSortDirectionEnum;

  /**
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListJobsRequest.
 * Use `create(ListJobsRequestSchema)` to create a new message.
 */
export const ListJobsRequestSchema: GenMessage<ListJobsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 6);

/**
 * @generated from message cortado.v1.ListJobsResponse
 */
export type ListJobsResponse = Message<"cortado.v1.ListJobsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.JobLite jobs = 1;
   */
  jobs: JobLite[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListJobsResponse.
 * Use `create(ListJobsResponseSchema)` to create a new message.
 */
export const ListJobsResponseSchema: GenMessage<ListJobsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 7);

/**
 * @generated from message cortado.v1.GetPipelineSummaryRequest
 */
export type GetPipelineSummaryRequest = Message<"cortado.v1.GetPipelineSummaryRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.JobListFilters filters = 2;
   */
  filters?: JobListFilters;
};

/**
 * Describes the message cortado.v1.GetPipelineSummaryRequest.
 * Use `create(GetPipelineSummaryRequestSchema)` to create a new message.
 */
export const GetPipelineSummaryRequestSchema: GenMessage<GetPipelineSummaryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 8);

/**
 * @generated from message cortado.v1.PipelineBucket
 */
export type PipelineBucket = Message<"cortado.v1.PipelineBucket"> & {
  /**
   * @generated from field: cortado.v1.JobPhaseEnum bucket = 1;
   */
  bucket: JobPhaseEnum;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * @generated from field: int64 quoted_cents = 3;
   */
  quotedCents: bigint;
};

/**
 * Describes the message cortado.v1.PipelineBucket.
 * Use `create(PipelineBucketSchema)` to create a new message.
 */
export const PipelineBucketSchema: GenMessage<PipelineBucket> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 9);

/**
 * PipelineStageBucket aggregates the jobs in one board stage.
 *
 * @generated from message cortado.v1.PipelineStageBucket
 */
export type PipelineStageBucket = Message<"cortado.v1.PipelineStageBucket"> & {
  /**
   * @generated from field: cortado.v1.JobBoardStageEnum stage = 1;
   */
  stage: JobBoardStageEnum;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * Sum of JobLite.quoted_cents.
   *
   * @generated from field: int64 quoted_cents = 3;
   */
  quotedCents: bigint;

  /**
   * Sum of JobLite.paid_cents.
   *
   * @generated from field: int64 paid_cents = 4;
   */
  paidCents: bigint;
};

/**
 * Describes the message cortado.v1.PipelineStageBucket.
 * Use `create(PipelineStageBucketSchema)` to create a new message.
 */
export const PipelineStageBucketSchema: GenMessage<PipelineStageBucket> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 10);

/**
 * @generated from message cortado.v1.GetPipelineSummaryResponse
 */
export type GetPipelineSummaryResponse = Message<"cortado.v1.GetPipelineSummaryResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PipelineBucket buckets = 1;
   */
  buckets: PipelineBucket[];

  /**
   * One bucket per JobBoardStageEnum value (all eight, zero-filled), in
   * pipeline order (see JobBoardStageEnum), over the same jobs as buckets.
   *
   * @generated from field: repeated cortado.v1.PipelineStageBucket stage_buckets = 5;
   */
  stageBuckets: PipelineStageBucket[];

  /**
   * @generated from field: int64 balance_due_cents = 2;
   */
  balanceDueCents: bigint;

  /**
   * @generated from field: int32 open_invoice_count = 3;
   */
  openInvoiceCount: number;

  /**
   * @generated from field: int32 overdue_invoice_count = 4;
   */
  overdueInvoiceCount: number;
};

/**
 * Describes the message cortado.v1.GetPipelineSummaryResponse.
 * Use `create(GetPipelineSummaryResponseSchema)` to create a new message.
 */
export const GetPipelineSummaryResponseSchema: GenMessage<GetPipelineSummaryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 11);

/**
 * @generated from message cortado.v1.UpdateJobRequest
 */
export type UpdateJobRequest = Message<"cortado.v1.UpdateJobRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 10;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateJobRequest.
 * Use `create(UpdateJobRequestSchema)` to create a new message.
 */
export const UpdateJobRequestSchema: GenMessage<UpdateJobRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 12);

/**
 * @generated from message cortado.v1.UpdateJobResponse
 */
export type UpdateJobResponse = Message<"cortado.v1.UpdateJobResponse"> & {
  /**
   * @generated from field: cortado.v1.Job job = 1;
   */
  job?: Job;
};

/**
 * Describes the message cortado.v1.UpdateJobResponse.
 * Use `create(UpdateJobResponseSchema)` to create a new message.
 */
export const UpdateJobResponseSchema: GenMessage<UpdateJobResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 13);

/**
 * @generated from message cortado.v1.ListJobActivityRequest
 */
export type ListJobActivityRequest = Message<"cortado.v1.ListJobActivityRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: repeated cortado.v1.JobActivityCategoryEnum categories = 2;
   */
  categories: JobActivityCategoryEnum[];

  /**
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListJobActivityRequest.
 * Use `create(ListJobActivityRequestSchema)` to create a new message.
 */
export const ListJobActivityRequestSchema: GenMessage<ListJobActivityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 14);

/**
 * @generated from message cortado.v1.JobActivityCategoryCount
 */
export type JobActivityCategoryCount = Message<"cortado.v1.JobActivityCategoryCount"> & {
  /**
   * @generated from field: cortado.v1.JobActivityCategoryEnum category = 1;
   */
  category: JobActivityCategoryEnum;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message cortado.v1.JobActivityCategoryCount.
 * Use `create(JobActivityCategoryCountSchema)` to create a new message.
 */
export const JobActivityCategoryCountSchema: GenMessage<JobActivityCategoryCount> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 15);

/**
 * @generated from message cortado.v1.ListJobActivityResponse
 */
export type ListJobActivityResponse = Message<"cortado.v1.ListJobActivityResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.ActivityLite activities = 1;
   */
  activities: ActivityLite[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: repeated cortado.v1.JobActivityCategoryCount category_counts = 3;
   */
  categoryCounts: JobActivityCategoryCount[];
};

/**
 * Describes the message cortado.v1.ListJobActivityResponse.
 * Use `create(ListJobActivityResponseSchema)` to create a new message.
 */
export const ListJobActivityResponseSchema: GenMessage<ListJobActivityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 16);

/**
 * @generated from message cortado.v1.ListJobEventsRequest
 */
export type ListJobEventsRequest = Message<"cortado.v1.ListJobEventsRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;
};

/**
 * Describes the message cortado.v1.ListJobEventsRequest.
 * Use `create(ListJobEventsRequestSchema)` to create a new message.
 */
export const ListJobEventsRequestSchema: GenMessage<ListJobEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 17);

/**
 * JobEventLite is one event on a job, in one shape for both sources. A booked
 * job's events are its events.events rows; a job with none yet uses its
 * inquiry's inquiry_events. The two are never mixed.
 *
 * @generated from message cortado.v1.JobEventLite
 */
export type JobEventLite = Message<"cortado.v1.JobEventLite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: cortado.v1.JobEventSourceEnum source = 2;
   */
  source: JobEventSourceEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_date = 20;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional double event_length = 21;
   */
  eventLength?: number;

  /**
   * @generated from field: optional string event_timezone = 22;
   */
  eventTimezone?: string;

  /**
   * The event's type, which is what the product shows as its name.
   *
   * @generated from field: optional string event_type_key = 23;
   */
  eventTypeKey?: string;

  /**
   * organizations.event_types.label for event_type_key, when the org has it.
   *
   * @generated from field: optional string event_type_label = 24;
   */
  eventTypeLabel?: string;

  /**
   * @generated from field: optional int32 event_guests = 25;
   */
  eventGuests?: number;

  /**
   * @generated from field: optional string event_location = 26;
   */
  eventLocation?: string;

  /**
   * Set for source EVENT only; inquiry events have no stage.
   *
   * @generated from field: optional cortado.v1.EventStageEnum stage = 50;
   */
  stage?: EventStageEnum;

  /**
   * Set for archived booked events (event_count includes them).
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 51;
   */
  archivedAt?: Timestamp;

  /**
   * Staff needed (Event.barista_count / InquiryEvent.barista_count), from
   * either source. Unset when not given.
   *
   * @generated from field: optional int32 barista_count = 52;
   */
  baristaCount?: number;

  /**
   * Staff assigned: the event's user_scheduling rows that are Pending or
   * Accepted. Rejected rows are excluded, so this is NOT
   * Event.scheduled_users_count (which counts every row). Set for source
   * EVENT only.
   *
   * @generated from field: optional int32 staff_assigned_count = 53;
   */
  staffAssignedCount?: number;

  /**
   * Google Calendar sync state, as Event.calendar_sync_status:
   * "synced" | "failed" | "skipped" | "skipped_policy" | "deleted".
   * Unset for inquiry events and until the first sync attempt completes.
   *
   * @generated from field: optional string calendar_sync_status = 54;
   */
  calendarSyncStatus?: string;

  /**
   * Staff on the event, Lead first, every status (Rejected included, so the
   * page can show it). Set for source EVENT only. Field 60+ is staffing.
   *
   * @generated from field: repeated cortado.v1.JobEventStaff staff = 60;
   */
  staff: JobEventStaff[];

  /**
   * Whether the booked event is ready to run, computed on the server. Set
   * for source EVENT only.
   *
   * @generated from field: optional cortado.v1.EventReadiness readiness = 70;
   */
  readiness?: EventReadiness;
};

/**
 * Describes the message cortado.v1.JobEventLite.
 * Use `create(JobEventLiteSchema)` to create a new message.
 */
export const JobEventLiteSchema: GenMessage<JobEventLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 18);

/**
 * EventReadiness is the event's logistics checklist: one check per
 * criterion, always in the order Staff, Questionnaire, Timeline, Inventory,
 * Directions, Calendar.
 *
 * @generated from message cortado.v1.EventReadiness
 */
export type EventReadiness = Message<"cortado.v1.EventReadiness"> & {
  /**
   * @generated from field: repeated cortado.v1.EventReadinessCheck checks = 1;
   */
  checks: EventReadinessCheck[];

  /**
   * Checks that are DONE.
   *
   * @generated from field: int32 ready_count = 2;
   */
  readyCount: number;

  /**
   * Checks that count toward readiness (every state but NOT_NEEDED).
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.EventReadiness.
 * Use `create(EventReadinessSchema)` to create a new message.
 */
export const EventReadinessSchema: GenMessage<EventReadiness> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 19);

/**
 * @generated from message cortado.v1.EventReadinessCheck
 */
export type EventReadinessCheck = Message<"cortado.v1.EventReadinessCheck"> & {
  /**
   * @generated from field: cortado.v1.EventReadinessCheckEnum check = 1;
   */
  check: EventReadinessCheckEnum;

  /**
   * @generated from field: cortado.v1.EventReadinessStateEnum state = 2;
   */
  state: EventReadinessStateEnum;

  /**
   * A short line for the checklist row, e.g. "1 of 2 needed · Lead: Kelby"
   * or "Guests changed since this list was made".
   *
   * @generated from field: string detail = 3;
   */
  detail: string;
};

/**
 * Describes the message cortado.v1.EventReadinessCheck.
 * Use `create(EventReadinessCheckSchema)` to create a new message.
 */
export const EventReadinessCheckSchema: GenMessage<EventReadinessCheck> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 20);

/**
 * JobEventStaff is one assignment on a job's event.
 *
 * @generated from message cortado.v1.JobEventStaff
 */
export type JobEventStaff = Message<"cortado.v1.JobEventStaff"> & {
  /**
   * @generated from field: string scheduling_id = 1;
   */
  schedulingId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 4;
   */
  lastName?: string;

  /**
   * @generated from field: cortado.v1.UserSchedulingRoleEnum role = 5;
   */
  role: UserSchedulingRoleEnum;

  /**
   * @generated from field: cortado.v1.UserSchedulingStatusEnum status = 6;
   */
  status: UserSchedulingStatusEnum;
};

/**
 * Describes the message cortado.v1.JobEventStaff.
 * Use `create(JobEventStaffSchema)` to create a new message.
 */
export const JobEventStaffSchema: GenMessage<JobEventStaff> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 21);

/**
 * @generated from message cortado.v1.ListJobEventsResponse
 */
export type ListJobEventsResponse = Message<"cortado.v1.ListJobEventsResponse"> & {
  /**
   * Ordered by event_date (unset last), then id.
   *
   * @generated from field: repeated cortado.v1.JobEventLite events = 1;
   */
  events: JobEventLite[];
};

/**
 * Describes the message cortado.v1.ListJobEventsResponse.
 * Use `create(ListJobEventsResponseSchema)` to create a new message.
 */
export const ListJobEventsResponseSchema: GenMessage<ListJobEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_jobs, 22);

/**
 * @generated from enum cortado.v1.EventReadinessCheckEnum
 */
export enum EventReadinessCheckEnum {
  /**
   * @generated from enum value: EVENT_READINESS_CHECK_UNSPECIFIED = 0;
   */
  EVENT_READINESS_CHECK_UNSPECIFIED = 0,

  /**
   * People scheduled (not declined) >= the event's barista count (at least 1).
   *
   * @generated from enum value: EVENT_READINESS_CHECK_STAFF = 1;
   */
  EVENT_READINESS_CHECK_STAFF = 1,

  /**
   * The booking questionnaire came back with no required question open.
   *
   * @generated from enum value: EVENT_READINESS_CHECK_QUESTIONNAIRE = 2;
   */
  EVENT_READINESS_CHECK_QUESTIONNAIRE = 2,

  /**
   * A saved run of show exists and still matches the event's details.
   *
   * @generated from enum value: EVENT_READINESS_CHECK_TIMELINE = 3;
   */
  EVENT_READINESS_CHECK_TIMELINE = 3,

  /**
   * Every needed packing-list row is packed and the list matches the event.
   *
   * @generated from enum value: EVENT_READINESS_CHECK_INVENTORY = 4;
   */
  EVENT_READINESS_CHECK_INVENTORY = 4,

  /**
   * The event has a location and a drive time from the shop.
   *
   * @generated from enum value: EVENT_READINESS_CHECK_DIRECTIONS = 5;
   */
  EVENT_READINESS_CHECK_DIRECTIONS = 5,

  /**
   * The event is on the team's Google Calendar.
   *
   * @generated from enum value: EVENT_READINESS_CHECK_CALENDAR = 6;
   */
  EVENT_READINESS_CHECK_CALENDAR = 6,
}

/**
 * Describes the enum cortado.v1.EventReadinessCheckEnum.
 */
export const EventReadinessCheckEnumSchema: GenEnum<EventReadinessCheckEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_jobs, 0);

/**
 * @generated from enum cortado.v1.EventReadinessStateEnum
 */
export enum EventReadinessStateEnum {
  /**
   * @generated from enum value: EVENT_READINESS_STATE_UNSPECIFIED = 0;
   */
  EVENT_READINESS_STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_READINESS_STATE_DONE = 1;
   */
  EVENT_READINESS_STATE_DONE = 1,

  /**
   * @generated from enum value: EVENT_READINESS_STATE_TODO = 2;
   */
  EVENT_READINESS_STATE_TODO = 2,

  /**
   * Done once but needs a look: details changed since a saved list or
   * timeline was made, or a calendar sync failed.
   *
   * @generated from enum value: EVENT_READINESS_STATE_ATTENTION = 3;
   */
  EVENT_READINESS_STATE_ATTENTION = 3,

  /**
   * Nothing to do (e.g. the booking has no questionnaire, or the event's
   * stage is outside the org's calendar sync settings). Not counted.
   *
   * @generated from enum value: EVENT_READINESS_STATE_NOT_NEEDED = 4;
   */
  EVENT_READINESS_STATE_NOT_NEEDED = 4,
}

/**
 * Describes the enum cortado.v1.EventReadinessStateEnum.
 */
export const EventReadinessStateEnumSchema: GenEnum<EventReadinessStateEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_jobs, 1);

